import { WorkerActionData } from '@/hooks/useSecWorker';
import { HostMessage } from '@/models/games/BaseHostMessage';
import { hostsSliceActions } from '@/modules/host/slice';
import { Action, Dispatch } from 'redux';
import { CMDScHostMessage, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScHostMessageHandler extends AbstractHandler {
    _command: CMDScHostMessage;
    _registWorkerAction: (item: WorkerActionData) => void;

    constructor(
        command: ICommand,
        registWorkerAction: (item: WorkerActionData) => void
    ) {
        super();
        this._command = command as CMDScHostMessage;
        this._registWorkerAction = registWorkerAction;
    }

    override handle(dispatch: Dispatch<Action>): void {
        dispatch(
            hostsSliceActions.updateHostMessageId({
                hostId: this._command.HostID,
                msgId: this._command.MsgID,
            })
        );
        if (this._command.MsgID === HostMessage.Resume) {
            this._registWorkerAction({
                key: `host-message-${this._command.HostID}`,
                time: 2,
                callbackFunc: () => {
                    dispatch(
                        hostsSliceActions.updateHostMessageId({
                            hostId: this._command.HostID,
                            msgId: HostMessage.NoMessage,
                        })
                    );
                },
            });
        }
    }
}
